@if (partner) {
  <div class="card shadow border-0 fade-in-zoom mt-3">
    <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
      <span>Block List</span>
      <button (click)="openForm()" class="btn btn-sm btn-primary fw-bold">Add Rule</button>
    </div>
    <div class="card-body">
      @if (loaded) {
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Rule</th>
              <th>SubID</th>
              <th>Action</th>
              <th class="text-end">Options</th>
            </tr>
          </thead>
          <tbody>
            @for (rule of rules; track rule) {
              <tr>
                <td>{{ rule.name }}</td>
                <td>{{ rule.subid }}</td>
                <td>{{ rule.blockTraffic ? 'Block traffic' : 'Redirect traffic to: ' }}@if (!rule.blockTraffic) {
                  <code><copy-to-clipboard [content]="rule.redirectUrl"></copy-to-clipboard></code>
                }</td>
                <td class="text-end">
                  <button (click)="openForm(rule)" type="button" class="btn btn-outline-primary btn-sm me-1">
                    <i class="bi bi-pencil me-2"></i>Edit
                  </button>
                  <button (click)="deleteRule(rule)" appConfirm class="btn btn-outline-danger btn-sm"><i class="bi bi-trash"></i></button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="d-flex align-items-center justify-content-center py-3">
          <div class="spinner-border spinner-border-sm text-primary opacity-50" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }
    </div>
  </div>
}
